module.exports = __webpack_public_path__ + "img/app_6.0cf1db1a.jpg";